<template>
	<div class="wd-theme-back">
		<Top></Top>
		<div class="wd-container">
			<div class="wd-h-40 wd-lh-40 wd-m-t-20">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
					<el-breadcrumb-item>会员中心</el-breadcrumb-item>
					<el-breadcrumb-item>我的订单</el-breadcrumb-item>
				</el-breadcrumb>
			</div>
			<div class="wd-flex wd-row-between usercenter wd-col-top ">
				<div class="left wd-row-noshrink">
					<div class="title">订单管理</div>
					<div class="other" @click="setflag('Orderlist')">我的订单</div>
					<!-- <div class="other" @click="setflag('Orderlist')">我的评价</div> -->
					<div class="other" @click="setflag('Servicelist')">退款售后</div>

					<div class="title">会员中心</div>
					<div class="other" @click="setflag('Myinfo')">个人信息</div>
					<div class="other" @click="setflag('Canuseamount')">账户余额</div>
					<div class="other" @click="setflag('Integral')">我的积分</div>
					<div class="other" @click="setflag('Couponlist')">优惠券</div>
					<div class="other" @click="setflag('Addrlist')">地址管理</div>
					<div class="other" @click="setflag('Safe')">安全设置</div>

					<div class="title">关注中心</div>
					<div class="other" @click="setflag('Favlist')">我的收藏</div>
					<div class="other" @click="setflag('Historylist')">我的浏览</div>
					
					<!-- <div class="title">分销中心</div>
					<div class="other" @click="setflag('Orderlist')">我的推广</div>
					<div class="other" @click="setflag('Orderlist')">我的收益</div> -->
				</div>
				<div class="right wd-row-grow wd-m-l-10 wd-theme-back-fff memdetail">
					<Orderlist v-if="flag==='Orderlist'"></Orderlist>
					<Integral v-else-if="flag==='Integral'"></Integral>
					<Canuseamount v-else-if="flag==='Canuseamount'"></Canuseamount>
					<Favlist v-else-if="flag==='Favlist'"></Favlist>
					<Historylist v-else-if="flag==='Historylist'"></Historylist>
					<Addrlist v-else-if="flag==='Addrlist'"></Addrlist>
					<Myinfo v-else-if="flag==='Myinfo'"></Myinfo>
					<Safe v-else-if="flag==='Safe'"></Safe>
					<Password v-else-if="flag==='Password'"></Password>
					<Paypassword v-else-if="flag==='Paypassword'"></Paypassword>
					<Mobile v-else-if="flag==='Mobile'"></Mobile>
					<Servicelist v-else-if="flag==='Servicelist'"></Servicelist>
					<Commentedit v-else-if="flag==='Commentedit'"></Commentedit>
					<Couponlist v-else-if="flag==='Couponlist'"></Couponlist>
					<Msglist v-else-if="flag==='Msglist'"></Msglist>
				</div>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
import Top from '@/components/layout/Top3.vue'
import Footer from '@/components/layout/Footer.vue'
import Orderlist from './components/Orderlist.vue'
import Integral from './components/Integral.vue'
import Canuseamount from './components/Canuseamount.vue'
import Favlist from './components/Favlist.vue'
import Historylist from './components/Historylist.vue'
import Addrlist from './components/Addrlist.vue'
import Myinfo from './components/Myinfo.vue'
import Safe from './components/Safe.vue'
import Password from './components/Password.vue'
import Paypassword from './components/Paypassword.vue'
import Mobile from './components/Mobile.vue'
import Servicelist from './components/Servicelist.vue'
import Commentedit from './components/Commentedit.vue'
import Couponlist from './components/Couponlist.vue'
import Msglist from './components/Msglist.vue'
export default {
	name: 'MemberIndex',
	components: {
		Top,
		Footer,
		Orderlist,
		Integral,
		Canuseamount,
		Favlist,
		Historylist,
		Addrlist,
		Myinfo,
		Safe,
		Password,
		Paypassword,
		Mobile,
		Servicelist,
		Commentedit,
		Couponlist,
		Msglist
	},
	data() {
		return {
			hotlist: [],
			flag:'Orderlist'
		};
	},
	methods: {
		setflag(newflag){
			this.flag=newflag;
		}
	},
	// updated() {
	// 	let aflag=this.$route.params.aflag||"";
	// 	if (aflag==""){
	// 		aflag=this.$route.query.aflag||"";
	// 	}
	// 	console.log(aflag);
	// 	if (aflag!=="" && aflag!==this.flag){
	// 		this.setflag(aflag)
	// 	}
	// }
	activated() {
		let aflag=this.$route.params.aflag||"";
		console.log(aflag);
		if (aflag==""){
			aflag=this.$route.query.aflag||"";
		}
		if (aflag!=="" && aflag!==this.flag){
			this.setflag(aflag)
		}
	}
};
</script>

<style lang="scss" scoped>
.usercenter {
	.left {
		padding: 20px 0;
		width: 180px;
		overflow: hidden;
		background-color: white;
		text-align: center;
		.title {
			font-size: 16px;
			margin: 0 0 9px;
			color: #333;
			position: relative;
			line-height: 26px;
		}
		.other {
			color: #999999;
			font-size: 14px;
			margin: 0 0 9px;
			position: relative;
			line-height: 26px;
			
			cursor: pointer;
		}
	}
	.right {
		background-color: white;
		padding: 10px;
	}
}
</style>
